import styled, { css } from 'styled-components';

import { NoSSR } from '@xing-com/crate-utils-no-ssr';

import { adSlotConfigPublift } from '../../ad-slot-config-publift';
import { useRegisterZone, useStickyPosition } from '../../hooks';

const AD_INITIAL_TOP = 290;
const AD_FIXED_TOP = 85;
const AD_MAX_HEIGHT = 600;
const STICKY_THRESHOLD = 287;

const OverflowContainer = styled.div`
  overflow-x: clip;
`;

const Wrapper = styled.div`
  width: 1030px;
  margin: 0 auto;
  position: relative;
`;

const AdContainer = styled.div<{ $isFixed: boolean; $topPosition: number }>`
  position: absolute;
  min-width: 120px;
  max-width: 300px;
  min-height: 250px;
  max-height: ${AD_MAX_HEIGHT}px;
  left: 100%;
  top: ${({ $topPosition }) => $topPosition}px;

  ${({ $isFixed }) =>
    $isFixed &&
    css`
      position: fixed;
      left: auto;
      top: ${AD_FIXED_TOP}px;
      margin-left: 1030px;
    `}
`;

export const DisplayAdProfileSidebarSlotPublift: React.FC = () => {
  const {
    isFixed,
    stickyElementRef: adContainerRef,
    topPosition,
    wrapperRef,
  } = useStickyPosition({
    fixedTopPosition: AD_FIXED_TOP,
    initialTopPosition: AD_INITIAL_TOP,
    maxHeight: AD_MAX_HEIGHT,
    stickyThreshold: STICKY_THRESHOLD,
  });

  const slotId = adSlotConfigPublift.Profile.sidebar.id;
  useRegisterZone(slotId);

  return (
    <NoSSR>
      <OverflowContainer>
        <Wrapper ref={wrapperRef}>
          <AdContainer
            ref={adContainerRef}
            $isFixed={isFixed}
            $topPosition={topPosition}
          >
            <div
              id={slotId}
              data-fuse={adSlotConfigPublift.Profile.sidebar.fuseTag}
            ></div>
          </AdContainer>
        </Wrapper>
      </OverflowContainer>
    </NoSSR>
  );
};
